import React from "react";
import Laboral from "./Laboral";
import { TituloTabla } from "../../shared/Estilos";
import { clienteAxios, useLog, Swal } from "../../shared/";

const ListarLaborales = ({
  lista,
  openModal,
  setSeleccionado,
  setConsultar,
  soloLectura
}) => {

  const [InsertarLog] = useLog(null);
  
  const borrar = async (id) => {
    try {
      await clienteAxios.delete("/personaslaboral", {
        params: { id },
      });
      InsertarLog( "eliminar", "Eliminacion de Experiencia Laboral");
      setConsultar(true);
    } catch (e) {}
  };

  const editar = (item) => {
    setSeleccionado(item);
    openModal();
  };

  const eliminar = (item) => {
    Swal.fire({
      title: "Esta Seguro que desea Eliminar?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Eliminar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.isConfirmed) {
        borrar(item.id);
      }
    });
  };

  return (
    <div className="table-responsive">
      <table className="table table-striped" style={{backgroundColor:"white"}}>
        <TituloTabla>
          <tr>
            <th scope="col" className="text-center">
              Relación
            </th>
            <th scope="col" className="text-center">
              Inscripción
            </th>
            <th scope="col" className="text-center">
              Empresa
            </th>
            <th scope="col" className="text-center">
              Actividad
            </th>
            <th scope="col" className="text-center">
              Fecha de Inicio
            </th>
            <th scope="col" className="text-center">
              Descripción
            </th>
            <th scope="col" className="text-center">
              Ingresos
            </th>
            <th scope="col" className="text-center">
              CUIT
            </th>
            <th scope="col" className="text-center">
              Acciones
            </th>
          </tr>
        </TituloTabla>
        <tbody>
          {lista.map((item) => (
            <Laboral
              key={item.id}
              item={item}
              editar={editar}
              eliminar={eliminar}
              soloLectura={soloLectura}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ListarLaborales;
